import { render } from "./SuccessTransaction.vue?vue&type=template&id=33d29202"
import script from "./SuccessTransaction.vue?vue&type=script&lang=js"
export * from "./SuccessTransaction.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__